import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPubstack = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 14 14",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M3.7667 12.9313C3.23337 12.398 3.23337 11.5315 3.7667 10.9983L6.05003 8.73196C6.58337 8.19872 7.45003 8.19872 7.98337 8.73196C8.5167 9.26521 8.5167 10.1317 7.98337 10.665L5.70003 12.9479C5.1667 13.4645 4.30003 13.4645 3.7667 12.9313Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M1.0665 3.74954C1.59984 3.2163 2.4665 3.2163 2.99984 3.74954L5.28317 6.0325C5.8165 6.56574 5.8165 7.43226 5.28317 7.96551C4.74984 8.49875 3.88317 8.49875 3.34984 7.96551L1.0665 5.68255C0.533171 5.14931 0.533171 4.28279 1.0665 3.74954Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M8.71641 6.04837C9.24974 5.51513 10.1164 5.51513 10.6497 6.04837L12.9331 8.33132C13.4664 8.86457 13.4664 9.73109 12.9331 10.2643C12.3997 10.7976 11.5331 10.7976 10.9997 10.2643L8.71641 7.98138C8.18307 7.44814 8.18307 6.58162 8.71641 6.04837Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			d: "M6.0499 5.31524C5.51657 4.782 5.51657 3.91547 6.0499 3.38223L8.36657 1.06595C8.8999 0.532705 9.76657 0.532705 10.2999 1.06595C10.8332 1.59919 10.8332 2.46572 10.2999 2.99896L7.98324 5.31524C7.4499 5.84849 6.58324 5.84849 6.0499 5.31524Z"
		})
	]
});
export default SvgPubstack;
